import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {formateTimeAgo} from 'src/utils/date-time-2';
import {useHistory} from 'src/rerouter/index';
import moment from 'moment';
import {NOTIFICATION_ICON} from 'src/components/crm/constant';
import {
  BodyMedium,
  BodySmall,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {Tooltip} from '@spaced-out/ui-design-system/lib/components/Tooltip';
import {Avatar} from '@spaced-out/ui-design-system/lib/components/Avatar';
import {getRedirectPath} from 'src/components/crm/lib/common';
import {useDispatch} from 'react-redux';
import {notificationClicked} from 'src/action-creators/crm';
import css from './notification.css';


type NotificationType = {
  id: number;
  title: string;
  body: string;
  createdOn: string;
  link: string;
  clicked: boolean;
  highlightedText: string[];
};

type NotificationProps = {
  notification: NotificationType;
  onNotificationClick: (notification: NotificationType) => void;
  handleClose: () => void;
};

const Notification = ({
  notification,
  onNotificationClick,
  handleClose,
}: NotificationProps) => {
  const router = useHistory();
  const dispatch = useDispatch();
  const {language} = useLabelTranslation();
  const handleNotificationClick = () => {
    const hashPath = notification.link.split('#')[1];
    const redirectPath = getRedirectPath(hashPath);
    if (redirectPath) {
      router.push(redirectPath);
    }
    if (!notification.clicked) {
      dispatch(notificationClicked(notification.id)).then(() => {
        onNotificationClick(notification);
      });
    }
    handleClose();
  };
  return (
    <div className={css.notification} onClick={handleNotificationClick}>
      <Avatar
        color="indigo"
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'New Feedback Submitted': "note"; readonly 'New IJP Submission': "megaphone"; readonly 'Job approval request APPROVED': "briefcase"; readonly 'Job approval request REJECTED': "briefcase"; ... 29 more ...; readonly 'Offer letter successfully generated': "file-check"; }'.
        iconName={NOTIFICATION_ICON[notification.title] || 'bell'}
        iconType="regular"
        size="small"
        // @ts-expect-error - TS2769 - No overload matches this call.
        status={!notification.clicked && 'information'}
      />
      <div className={css.notificationContent}>
        <BodyMedium
          highlightedTextClassName={css.highlightedText}
          highlightString={notification.highlightedText}
        >
          {notification.body}
        </BodyMedium>
        <Tooltip
          title={moment(notification.createdOn)
            .locale(language)
            .format('Do MMMM YYYY, h:mm a')}
          placement="top"
          elevation="modal"
        >
          <BodySmall color="secondary" className={css.timeAgo}>
            {formateTimeAgo(
              new Date(notification.createdOn).toISOString(),
              language,
            )}
          </BodySmall>
        </Tooltip>
      </div>
    </div>
  );
};

export default Notification;
